import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import logError from '../../utils/logError'
import styles from './styles'
import { HOST } from '../../utils/env'
import Button from '../Button'
import Group from '../Group'

const PageError = ({
  mostPopular,
  code,
  currentUrl,
  httpStatus,
  slug,
}) => {
  const [data, setData] = useState('')
  const [background, setBackground] = useState({})

  const errorMessage = slug === 'search'
    ? 'search'
    : '404'

  logError({
    code,
    source: 'page-error',
    url: currentUrl,
    httpStatus,
  })

  useEffect(() => {
    const url = `https://strapi.cms.${HOST}/api/error-screens?populate=deep&filters[errorType]=${errorMessage}`
    try {
      fetch(url)
        .then(response => response.json())
        .then((result) => {
          if (result && result.data) {
            setData(result?.data[0]?.attributes)
          }
          return null
        })
    } catch {
      setData({})
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line max-len
    if (window.screen.width >= 767) { setBackground(data?.BackgroundImage?.data?.attributes?.url) } else { setBackground(data?.MobileBackgroundImage?.data?.attributes?.url) }
  }, [data])

  return (
    <div className="PageError">
      <div className="outer-wrapper" style={{ backgroundImage: `url(${background})` }}>
        <div className="inner-wrapper">
          <div className="header">
            <div className="error-page-text">
              <h1 className="error-title">{data?.Title}</h1>
              <p className="error-subtitle">{data?.Subtitle}</p>
            </div>
            {data?.PrimaryButtonLink && (
              <div className="error-page-buttons">
                <Button
                  variant="primary"
                  href={data?.PrimaryButtonLink}
                  text={data?.PrimaryButtonText}
                  style={{ marginBottom: 0 }}
                />
                {data?.SecondaryButtonLink && (
                  <Button
                    variant="secondary"
                    href={data?.SecondaryButtonLink}
                    text={data?.SecondaryButtonText}
                  />
                )}
              </div>
            )}
          </div>

        </div>

        {mostPopular && (
          <div className="most-popular-row">
            <Group
              key={mostPopular?.id}
              {...mostPopular}
              showTitle
              specialEvent={false}
              showCardTitle
              rowTitle={'Top Picks'}
              name={'Top Picks'}
            />
          </div>
        )}

      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

PageError.propTypes = {
  code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentUrl: PropTypes.string.isRequired,
  httpStatus: PropTypes.number,
  mostPopular: PropTypes.object.isRequired,
  slug: PropTypes.string,
}

PageError.defaultProps = {
  code: null,
  httpStatus: null,
  slug: null,
}

export default PageError
